export interface LicensePlateValidationError {
  errorType: LicensePlateValidationErrorType;
  carFound?: string;
}

export interface ProductLicensePlate {
  productId: string;
  licensePlateNumber: string;
}

export interface ProductLicensePlateValidationState {
  licensePlateNumber?: string;
  isLoading: boolean;
  error?: LicensePlateValidationError;
}

export interface ValidateLicensePlateState {
  [productId: string]: ProductLicensePlateValidationState;
}

export enum LicensePlateValidationErrorType {
  INVALID_PRODUCT_CHANGE = "Invalid Product Change",
  UNKNOWN_CAR = "Unknown Car",
  CAR_NOT_PURCHASEABLE = "Car Not Purchaseable",
  CAR_UNINSURED = "Car Uninsured",
  INSURANCE_STATUS_INVALID = "Insurance Status Invalid",
  INSURANCE_ALREADY_EXISTS = "Insurance Already Exists",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}
